import React from "react";

const ServerError = () => {
  return (
    <div className="bg-white">
      <section className="flex items-center p-16 dark:bg-gray-50 dark:text-gray-800 overflow-hidden h-screen">
        <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
          <div className="max-w-md text-center">
            <h2 className="mb-8 font-medium text-9xl dark:text-gray-400">
              <span className="sr-only">Error</span>
            </h2>
            <p className="text-2xl font-medium md:text-3xl">
              Oops! Something went wrong.
            </p>
            <p className="mt-4 mb-8">Please refresh the page and try again.</p>
            <button onClick={() => window.location.reload()} className="blue_btn py-2 px-7">
              Refresh Now
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServerError;
